// eslint-disable-next-line import/export
import * as loaders from "loaders/legacy/legacy-glTF1FileLoader";
export { loaders };
export default loaders;
